const INITIAL_STATE = {
  user: {
    first_name: "Faisal",
    last_name: "Al-Haddad",
    username: "099999",
    token: "test",
    user_type: "company_owner",
    is_login: true,
  },
  provinces: [],
};

const Store = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "GET_USERS":
      return {
        ...state,
        users: action.data,
      };
    case "GET_PROVINCES":
      return {
        ...state,
        provinces: action.data,
      };
    case "LOGIN_USER":
      return {
        ...state,
        user: {
          ...action.user,
          is_login: true,
        },
      };

    case "LOGOUT_USER":
      return INITIAL_STATE;

    case "EXCEL_SUMMARY":
      return {
        ...state,
        excel_summary: action.data,
      };

    default:
      return state;
  }
};
export default Store;
